/**
 * バリデーションメッセージのオブジェクト
 * @constant {object} jaMessages
 */
const jaMessages = {
    REQUIRED: '入力してください',
    REQUIRED_SELECT: '選択してください',
    ANY_REQUIRED: '1ヵ所以上、入力してください。',
    TEL: '電話番号を入力してください',
    MAIL: 'メールアドレスを入力してください',
    NUM: '数字を入力してください',
    ALPHABET: 'アルファベットを入力してください',
    ALPHA_NUM: '英数字を入力してください',
    ZIP: '郵便番号を入力してください',
    ADDR: '住所を入力してください',
    KANA: 'ひらがなまたはカタカナを入力してください',
    HIRAGANA: 'ひらがなを入力してください',
    KATAKANA: 'カタカナを入力してください',
    NO_INPUT: '入力に不備のある項目があります',
};
export default jaMessages;
//# sourceMappingURL=ja.js.map